export default "__VITE_ASSET__cfkVEi5M__"